<template>
  <div class="about-page">
    <div class="header">
      <h1>关于我们</h1>
    </div>
    
    <div class="content-section">
      <el-card class="content-card">
        <div class="section">
          <h2>公司简介</h2>
          <p>
            51软件下载平台致力于为用户提供安全、可靠、便捷的软件下载服务。我们专注于收集和整理各类优质软件资源，
            为用户提供一站式的软件下载体验。平台拥有丰富的软件资源，涵盖系统工具、多媒体、安全软件、办公软件等多个类别。
          </p>
        </div>
        
        <div class="section">
          <h2>我们的使命</h2>
          <p>
            我们的使命是让每一个用户都能轻松获取到安全、正版的软件资源，享受科技带来的便利。
            我们坚持用户至上的原则，不断提升服务质量，努力成为用户最信赖的软件下载平台。
          </p>
        </div>
        
        <div class="section">
          <h2>服务优势</h2>
          <ul>
            <li>✅ <strong>安全可靠</strong>：所有软件均经过严格检测，确保无病毒、无恶意插件</li>
            <li>✅ <strong>资源丰富</strong>：涵盖各类软件资源，满足不同用户需求</li>
            <li>✅ <strong>高速下载</strong>：提供多线程下载，确保下载速度</li>
            <li>✅ <strong>及时更新</strong>：软件版本更新及时，保证用户使用最新版本</li>
            <li>✅ <strong>专业技术支持</strong>：提供专业的技术支持和售后服务</li>
          </ul>
        </div>
        
        <div class="section">
          <h2>联系我们</h2>
          <div class="contact-info">
            <p><strong>公司名称：</strong>奇安科技有限公司贵州分公司</p>
            <p><strong>客服邮箱：</strong>softdown51@outlook.com</p>
            <!-- <p><strong>客服电话：</strong>400-123-4567</p> -->
            <p><strong>公司地址：</strong>贵州省贵阳市南明区兴关路街道遵义路105号万象国际C栋3单元19层8号</p>
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AboutPage'
}
</script>

<style scoped>
.about-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

.header {
  text-align: center;
  margin-bottom: 30px;
}

.header h1 {
  font-size: 28px;
  color: #333;
  margin: 0;
}

.content-section {
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(24, 144, 255, 0.08);
  border: 1px solid rgba(24, 144, 255, 0.1);
  overflow: hidden;
}

.content-card {
  border: none;
}

.section {
  margin-bottom: 30px;
}

.section:last-child {
  margin-bottom: 0;
}

.section h2 {
  font-size: 20px;
  color: #1890ff;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #f0f0f0;
}

.section p {
  color: #666;
  line-height: 1.8;
  font-size: 15px;
}

.section ul {
  padding-left: 20px;
}

.section li {
  color: #666;
  line-height: 1.8;
  margin-bottom: 10px;
  font-size: 15px;
}

.contact-info p {
  margin-bottom: 10px;
  font-size: 15px;
}

.contact-info strong {
  color: #333;
}
</style>